// Сотрудники аутстафф
import { create } from 'zustand';
import { getCustomersOutstaff, addCustomerOutstaff } from 'services/customersOutstaff';

export const useCustomersOutstaff = create((set) => ({
	customersOutstaff: [],
	customerOutstaffId: null, // id клиента
	loading: false,
	getCustomersOutstaff: async () => {
		set({ loading: true });
		const customersOutstaff = await getCustomersOutstaff();
		set({ customersOutstaff, loading: false });
	},
	// Добавить клиента
	addCustomerOutstaff: async (updatedClient) => {
		const customerId = await addCustomerOutstaff(updatedClient);
		return customerId;
	},
	setCustomersOutstaff: (customersOutstaff) => {
		set({ customersOutstaff });
	},
	// добавить id клиента
	setCustomerOutstaffId: (customerOutstaffId) => {
		set({ customerOutstaffId });
	},
	// очистить id клиента
	clearCustomerOutstaffId: () => {
		set({ customerOutstaffId: null });
	}
}))